import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Menu, Button } from 'antd'
import { CaretDownOutlined, CheckOutlined, DeleteOutlined, EditOutlined, FilePdfOutlined, MailOutlined } from '@ant-design/icons'
import styles from './styles.css'

const Header = props => {

  const {
    subOrder,
    onClickEdit,
    onClickDelete,
    onClickPdf,
    onClickSubbyPdf,
    onClickEmail,
    onClickSendForApproval,
  } = props

  return (

    <div className={styles.wrapper}>

      <h1 className={styles.header}>{subOrder.reference}</h1>

      <Dropdown
        trigger={['click']}
        overlay={(
          <Menu>
            <Menu.Item key='edit' icon={<EditOutlined />} onClick={onClickEdit}>Edit Details</Menu.Item>
            <Menu.Item key='delete' icon={<DeleteOutlined />} onClick={onClickDelete}>Delete Order</Menu.Item>
            <Menu.Divider />
            <Menu.Item key='pdf' icon={<FilePdfOutlined />} onClick={onClickPdf}>Purchase Order (PDF)</Menu.Item>
            <Menu.Item key='subbyPdf' icon={<FilePdfOutlined />} onClick={onClickSubbyPdf}>Subby Purchase Order (PDF)</Menu.Item>
            <Menu.Item key='send' icon={<MailOutlined />} onClick={onClickEmail}>Send via Email</Menu.Item>
            <Menu.Item key='sendForApproval' icon={<CheckOutlined />} onClick={onClickSendForApproval}>Send PO for Approval</Menu.Item>
          </Menu>
        )}
      >
        <Button type='primary'>
          Actions
          <CaretDownOutlined />
        </Button>
      </Dropdown>

    </div>

  )

}

Header.propTypes = {
  subOrder: PropTypes.object.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  onClickPdf: PropTypes.func.isRequired,
  onClickSubbyPdf: PropTypes.func.isRequired,
  onClickEmail: PropTypes.func.isRequired,
  onClickSendForApproval: PropTypes.func.isRequired,
}

export default Header
